import ProductPlacement from '../product-placement';
import DistanceToBottom from './distance-to-bottom';

export default class BoardPlacement extends ProductPlacement {
  newWoodPosts?: boolean;
  obstaclesPresent: boolean;
  obstaclesInfo?: string;
  canParkNearby?: boolean;
  nearbyParkingInfo?: string;

  constructor() {
    super();
  }
}

export const DistanceToBottomChoices = {
  CUSTOM: new DistanceToBottom('Aangepast', 0)
};

export const DistanceToBottomChoiceArray = Object.values(
  DistanceToBottomChoices
);
